import script from "./ClosedBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClosedBanner.vue?vue&type=script&setup=true&lang=ts"

import "./ClosedBanner.vue?vue&type=style&index=0&id=52f1d444&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f1d444"]])

export default __exports__